import React, { useState } from "react";
import ImportDrivers from "../../import/ImportDrivers";
import StyledDrawer from "../StyledDrawer";

export default function DriversUploadDialog({ open, handleClose }) {
  const [loadingImport, setLoadingImportLeft] = useState(false);

  return (
    <StyledDrawer open={open} handleClose={handleClose} loading={loadingImport}>
      <ImportDrivers
        loadingImport={false}
        setLoadingImportLeft={setLoadingImportLeft}
      />
    </StyledDrawer>
  );
}
